// extracted by mini-css-extract-plugin
module.exports = {"main-component":"talkOnAgile_main-component__1mOTK"};